import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { SheetDatanew } from '../../../services/auth-service/authService'
import { Fetchexecutequery,Fetchheaderdata,Fetchupdatequery  } from '../../../services/process/BRS1/brsService1';
import { AgGridReact } from 'ag-grid-react';
import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';
import {GetProcessNames, SaveRelationship,CreateData } from '../../../services/process/process_data/process_data';
import './relationship.css';

const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const identifier1 = [
  { value: "mysql", label: "Mysql" }
];


const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};


const Headerconfig = () => {
  const [configName, setConfigName] = useState('');
  const [description, setDescription] = useState('');
  const [headerid, setHeaderid] = useState('');
  const [database, setDatabase] = useState('');
  const [relationshipType, setRelationshipType] = useState({});
  const [databaseNames, setDatabaseOptions] = useState([]);
  const [tableNames, setTableOptions] = useState([]);
  const [tableNames1, setTableOptions1] = useState([]);
  const [functionNames, setFunctionOptions] = useState([]);
  const [headerNames, setHeaderOptions] = useState([]);
  const [selectedprocess1, setSelectedprocess1] = useState([]);
  const [rows, setRows] = useState([{ type: 'drop_rows',selectedOption: null,customoptions :{droprows:"",rowindex:"",columnindex:"",index: null,value: null,sourceColumns: "",dropcolumns:"",dropcondition:""}}]);
  const [rows2, setRows2] = useState([{ type: 'fill_rows',selectedOption: null,customoptions: {column: null,row: null,value: "",sourceColumns: null,valuetofill:""}}]);
  const [rows3, setRows3] = useState([{ type: 'renaming_columns',selectedOption: null,customoptions :{columntype: "",renamingcolumn:null,schema:"",table:"",columnname:""}}]);
  const [rows4, setRows4] = useState([{  type: 'duplicate_check',selectedOption: null,customoptions :{schema:"",table:"",headername:""}}]);
  const [rows5, setRows5] = useState([{  type: 'value_corrections',selectedOption: null,customoptions :{dateformat:"",correction_type: null,valuetocheck: "",valuetoreplace:"",schema:"",table:"",headername:""}}]);
  const [rows6, setRows6] = useState([{  type: 'keep_columns',selectedOption: null,customoptions :{schema:"",table:"",headername:""}}]);
  const [selectedSource, setSelectedSource] = useState('');
  const [selectedSchema, setSelectedSchema] = useState('');
  const [selectedTable, setSelectedTable] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [selectedHeader, setSelectedHeader] = useState('');
  const [selectedFunction, setSelectedFunction] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fields, setFields] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [filterconditions,setFilterconditions] =  useState([]);
  const [sources, setSources] = useState([]);
  const [sourceColumns, setSourceColumns] = useState([]);

  const [isDiv1Open, setIsDiv1Open] = useState(false);
  const [isDiv2Open, setIsDiv2Open] = useState(false);
  const [isDiv3Open, setIsDiv3Open] = useState(false);
  const [isDiv4Open, setIsDiv4Open] = useState(false);
  const [isDiv5Open, setIsDiv5Open] = useState(false);
  const [isDiv6Open, setIsDiv6Open] = useState(false);


  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);
  const toggleDiv5 = () => setIsDiv5Open(!isDiv5Open);
  const toggleDiv6 = () => setIsDiv6Open(!isDiv6Open);


  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };



const handleChange = (index, key, value) => {
  const updatedRows = [...rows];
  updatedRows[index][key] = value;
  setRows(updatedRows);
};

const handleChange2 = (index, key, value) => {
  const updatedRows = [...rows2];
  updatedRows[index][key] = value;
  setRows2(updatedRows);
};

const handleChange3 = (index, key, value) => {
  console.log("change3",index, key, value);
  const updatedRows = [...rows3];
  updatedRows[index][key] = value;
  setRows3(updatedRows);
};

const handleChange4 = (index, key, value) => {
  const updatedRows = [...rows4];
  updatedRows[index][key] = value;
  setRows4(updatedRows);
};

const handleChange5 = (index, key, value) => {
  const updatedRows = [...rows5];
  updatedRows[index][key] = value;
  setRows5(updatedRows);
};

const handleChange6 = (index, key, value) => {
  const updatedRows = [...rows6];
  updatedRows[index][key] = value;
  setRows6(updatedRows);
};


const addRow = () => {
  setRows([...rows, { type: 'drop_rows',selectedOption: null,customoptions :{dropcondition:"",index: null,value: null,sourceColumns: "",dropcolumns:"",columnindex:"",droprows:"",rowindex:""}}]);
};
const addRow2 = () => {
  setRows2((prevRows) => [
    ...prevRows,
    { type: 'fill_rows',
      selectedOption: null, // Default to no option selected
      customoptions: {
        column: null, // Default value for column
        row: null,    // Default value for row
        value: "",    // Default empty value
        sourceColumns: null, // Default for sourceColumns
        valuetofill:""
      },

    },
  ]);
};
const addRow3 = () => {
  setRows3([...rows3, { type: 'renaming_columns',selectedOption: null,customoptions :{columntype: "",renamingcolumn:null,schema:"",table:"",columnname:""}}]);
};
const addRow4 = () => {
  setRows4([...rows4, { type: 'duplicate_check',selectedOption: null,customoptions :{schema:"",table:"",headername:""} }]);
};

const addRow5 = () => {
  setRows5([...rows5, { type: 'value_corrections',selectedOption: null,customoptions :{dateformat:"",correction_type: null,valuetocheck: "",valuetoreplace:"",schema:"",table:"",headername:""}}]);
};

const addRow6 = () => {
  setRows6([...rows6, { type: 'keep_columns',selectedOption: null,customoptions :{schema:"",table:"",headername:""} }]);
};

const deleteRow = (index) => {
  if (rows.length > 1) {
  const updatedRows = rows.filter((_, i) => i !== index);
  setRows(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};

const deleteRow2 = (index) => {
  if (rows2.length > 1) {
  const updatedRows = rows2.filter((_, i) => i !== index);
  setRows2(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};

const deleteRow3 = (index) => {
  if (rows3.length > 1) {
  const updatedRows = rows3.filter((_, i) => i !== index);
  setRows3(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};

const deleteRow4 = (index) => {
  if (rows4.length > 1) {
  const updatedRows = rows4.filter((_, i) => i !== index);
  setRows4(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};

const deleteRow5 = (index) => {
  if (rows5.length > 1) {
  const updatedRows = rows5.filter((_, i) => i !== index);
  setRows5(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};

const deleteRow6 = (index) => {
  if (rows6.length > 1) {
  const updatedRows = rows6.filter((_, i) => i !== index);
  setRows6(updatedRows);
} else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};


  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
  };

const deleteRowInSection2 = (index) => {
  if (section2Rows.length > 1) {
    // Optional confirmation before deleting
    const confirmDelete = window.confirm("Are you sure you want to delete this row?");
    if (!confirmDelete) return;
    
    // Update rows by filtering out the specified index
    const updatedRows = section2Rows.filter((_, rowIndex) => rowIndex !== index);
    setSection2Rows(updatedRows);

    // Optional: Log the updated rows for debugging
    console.log("Updated rows after deletion:", updatedRows);
  } else {
    // Optional: Handle case where only one row exists
    console.warn("Cannot delete the last row.");
  }
};


  const addRowInSection2 = () => {
    setSection2Rows([...section2Rows, {}]);  // Adds an empty object as a new row
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };



  // Handle the change event for the Select component
  const handleSelectChange = (event, { value }) => {
    Fetchdatabaseinfo1();
    setDatabase(event);
  };

  const handleSelectChange1 = (event, { value }) => {
    fetchtabledata(event);
    setSelectedSchema(event);
  };

  const handleSourceselection = (event) => {
    fetchSourceData(event);
    setSelectedSource(event);
    };

  const handleUpdate = () => {
    
    console.log('formData')
    const sanitizedRows = rows.map(({ headerOptions, tableOptions1, ...rest }) => rest);
    const payload = {
      schema_name: 'process_data',
      table: 'file_configuration',
      set_column : [{'file_config_name': configName},{'source_id_json':selectedSource},{'setdatabase_json':database},
{'description':description},{'configuration_json': [{"drop_rows": rows, "fill_rows":rows2,"value_corrections":rows5,keep_columns:rows6, "duplicate_check": rows4,"renaming_columns": rows3}]}],
      'where' : [{"primary_id":headerid}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

const handleCustomOptionChange = (index, field, value) => {
  console.log("row options", value, index, field, rows);
  setRows((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: { // Match the property name
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};

const handleCustomOptionChange2 = (index, field, value) => {
  console.log("row options", value, index, field, rows);
  setRows2((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: { // Match the property name
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};

const handleCustomOptionChange3 = (index, field, value) => {
  console.log("row options", value, index, field, rows3,value.value)
  if (field === 'schema'){
    setSelectedSchema(value);
    fetchtabledata(value.value);}
  if (field === 'table'){
    fetchheaderdata(value.value);}
  setRows3((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: {
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};

const handleCustomOptionChange4 = (index, field, value) => {
  console.log("")
  if (field === 'schema'){
    setSelectedSchema(value);
    fetchtabledata(value.value);}
  if (field === 'table'){
    fetchheaderdata(value.value);}
    setRows4((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: { // Match the property name
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};

const handleCustomOptionChange5 = (index, field, value) => {
  console.log("row options", value, index, field, rows);
  if (field === 'schema'){
    setSelectedSchema(value);
    fetchtabledata(value.value);}
  if (field === 'table'){
    fetchheaderdata(value.value);}

  setRows5((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: { // Match the property name
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};

const handleCustomOptionChange6 = (index, field, value) => {
  console.log("")
  if (field === 'schema'){
    setSelectedSchema(value);
    fetchtabledata(value.value);}
  if (field === 'table'){
    fetchheaderdata(value.value);}
    setRows6((prevRows) =>
    prevRows.map((row, rowIndex) => {
      if (rowIndex === index) {
        return {
          ...row,
          customoptions: { // Match the property name
            ...row.customoptions,
            [field]: value,
          },
        };
      }
      return row;
    })
  );
};


  const handleEditClick = (row) => {
    console.log("Editing row:", row,row.headerconfig_id);
    // setFormData(row); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
    Fetcheditinfo(row.primary_id);
  };


  const handleSelectChange2 = (event, { value }) => {
    fetchheaderdata(event);
    setSelectedTable(event);
  };

  const handleSelectChange3 = (event) => {
    console.log("table",selectedTable)
    setSelectedHeader(event);
  };

  const handleSelectChange4 = (event, { value }) => {
    setSelectedFunction(event);
  };


  const handleRemove = (headerToRemove) => {
    const updatedHeaders = selectedHeader.filter(header => header.value !== headerToRemove.value);
    setSelectedHeader(updatedHeaders);
  };

  const handleCustomOptionChange123 = (index, field, value) => {
    const updatedRows = [...rows];  // shallow copy rows
    const updatedCustomOptions = { ...updatedRows[index].customOptions }; // shallow copy customOptions

    // update customOptions field
    updatedCustomOptions[field] = value;

    // update the row with the new customOptions
    updatedRows[index].customOptions = updatedCustomOptions;
    console.log(index, field, value,updatedRows)
    setRows(updatedRows);
  };


  const handleCreate = () =>{
    let payload = {
	'database':'process_data',
	'table':'file_configuration',
	 formData: {'file_config_name': configName,
	'description':description,
        'source_id_json':selectedSource,
        'setdatabase_json':database,
	'configuration_json': [{"drop_rows": rows, "fill_rows":rows2,"value_corrections":rows5,"keep_columns":rows6, "duplicate_check": rows4,"renaming_columns": rows3}]
    }    }
    console.log('payload', payload)
    var FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                window.location.reload();
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }

  const Fetchheaderinfo1 = () => {
    let payload = {

      query:`select * from header_config where headerconfig_id=10;`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)

          const dropdownOptions = data.map(item => ({
              value: item.Database, // The value for the dropdown option
              label: item.Database  // The label for the dropdown option
          }));
          console.log(dropdownOptions);
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }


const dateFormatOptions = [
  { value: "MM/DD/YYYY", label: "MM/DD/YYYY" },
  { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
  { value: "YYYY-MM-DD", label: "YYYY-MM-DD" }
];

const dateFormatOptions2 = [
  { value: "day", label: "Day" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" }
];

const inputfieldOptions = [
  { value: "decimal", label: "Decimal" },
  { value: "integer", label: "Integer" },
  { value: "text", label: "Text" },
  { value: "date", label: "Date" },

];


  const fetchtabledata = (database) => {
     let payload = {

      query:`show tables from ${database}`

    }
    console.log('payload---', database)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
          const dropdownOptions = data.map(item => ({
              value: item[`Tables_in_${database}`], // The value for the dropdown option
              label: item[`Tables_in_${database}`] // The label for the dropdown option
          }));
          console.log(dropdownOptions);
          setTableOptions(dropdownOptions)
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }



 const fetchSourceData = (event) => {
    console.log("source event", event);

    // Payload for the request
    let payload = {
        query: `select columns from process_data.source_master where source_id = ${event.value}`
    };

    console.log('payload---', database.label);

    // Get credentials or other details for API request
    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---', FileUploadCredentials[0]);

    // Make API request to fetch data
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(response => {
            console.log("Validate Credentials Response!!!", response);
            let data = response.data; // Response data
            
            // Initialize a Set to store unique names
            let names = new Set();
            console.log("source data",data)
let parsedColumns = JSON.parse(data[0].columns);
let columnNames = [];
parsedColumns.forEach(item => {
  item.datatype.forEach(datatypeObj => {
    columnNames.push(...Object.keys(datatypeObj));
  });
});

// Remove duplicates, if any
columnNames = [...new Set(columnNames)];

console.log(columnNames);  // This will print an array of column names
         
          const dropdownOptions = columnNames.map(item => ({
              value: item, // The value for the dropdown option
              label: item  // The label for the dropdown option
          }));
          setSourceColumns(dropdownOptions);

        })
        .catch((error) => {
            console.error("Error in database request:", error);
        });
};

const fetchTableInfo1 = async () => {
    let payload = {
        query: `select columns from process_data.source_master where source_id =5`
    };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = {fields:[{columnName: 'primary_id'},{columnName: 'file_config_name'},{columnName: 'description'},{columnName: 'source_id'},{columnName: 'configuration'}]};
      console.log("data",data)
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const fetchtabledata1 = (database, index) => {
    let payload = {
      query: `show tables from ${database.label}`
    }
    console.log('payload---', database.label)
  
    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---', FileUploadCredentials[0])
  
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
          const dropdownOptions = data.map(item => ({
            value: item[`Tables_in_${database.label}`], // The value for the dropdown option
            label: item[`Tables_in_${database.label}`] // The label for the dropdown option
          }));
          console.log(dropdownOptions);
  
          // Update the state for the specific row
          const updatedRows = [...rows];
          updatedRows[index].tableOptions1 = dropdownOptions;
          setRows(updatedRows);
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }

const generateColumnOptions = () => {
  const options = [];
  for (let i = 0; i < 26; i++) {
    options.push({ value: String.fromCharCode(65 + i), label: String.fromCharCode(65 + i) });
  }
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      const column = String.fromCharCode(65 + i) + String.fromCharCode(65 + j);
      options.push({ value: column, label: column });
    }
  }
  return options;
};

const generateRowOptions = () => {
  return Array.from({ length: 1000 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));
};

  const fetchfunctionoptions = () => {
          let data = ['Input Field','Dropdown','Data Displayer','Data Displayer with reference', 'Date Field','File Upload','File Displayer','Table Header'];
          console.log(data)
          const dropdownOptions = data.map(item => ({
              value: item, // The value for the dropdown option
              label: item // The label for the dropdown option
          }));
          console.log(dropdownOptions);
          setFunctionOptions(dropdownOptions)
  }



  const fetchheaderdata = (table) => {
    console.log('payload---', table,database,selectedSchema)
     let payload = {

      query:`desc ${selectedSchema.value}.${table}`

    }
    console.log('payload---', table,database)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
          const dropdownOptions = data.map(item => ({
              value: item.Field, // The value for the dropdown option
              label: item.Field // The label for the dropdown option
          }));
          console.log(dropdownOptions);
          setHeaderOptions(dropdownOptions)
        }
      )
      .catch((error) => {
        console.error("Error in header request:", error);
      });
  }

const fetchheaderdata1 = (table, schema, index) => {
  console.log('payload---', table, schema)
  let payload = {
    query: `desc ${schema.value}.${table.value}`
  }
  console.log('payload---', table.value, schema.value)

  var FileUploadCredentials = Fetchexecutequery();
  console.log('FileUploadCredentials---', FileUploadCredentials[0])

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
    .then(
      response => {
        console.log("Validate Credentials Response!!!", response);
        let data = response["data"];
        console.log(data)
        const dropdownOptions = data.map(item => ({
          value: item.Field, // The value for the dropdown option
          label: item.Field // The label for the dropdown option
        }));
        console.log(dropdownOptions);
        // Update the state for the specific row
        const updatedRows = [...rows];
        updatedRows[index].headerOptions = dropdownOptions;
        setRows(updatedRows);
      }
    )
    .catch((error) => {
      console.error("Error in header request:", error);
    });
}


  const fetchProcessNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.process_id,
                        label: data.process_name
                    }
                    names.push(obj);
                })
                setSelectedprocess1(names);
            }
        )
}

const FetchSourcenames = () => {
  let payload = {
    query: `SELECT source_id,source_name FROM process_data.source_master;`
  };
  console.log('payload---', payload);

  // Assuming Fetchexecutequery is defined and returns an array
  var FileUploadCredentials = Fetchexecutequery();
  console.log('FileUploadCredentials---', FileUploadCredentials[0]);

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
    .then((response) => {
      console.log("Validate Credentials Response!!!", response);
      let data = response.data;
      
      // Mapping the response data to the desired format
      let sourcenames = data.map(item => ({
        value: item.source_id,
        label: item.source_name
      }));
      
      setSources(sourcenames); // Setting the mapped sources to state
    })
    .catch((error) => {
      console.error("Error in database request:", error);
    });
};



  const Fetchdatabaseinfo1 = () => {
    let payload = {

      query:`show databases`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
          const dropdownOptions = data.map(item => ({
              value: item.Database, // The value for the dropdown option
              label: item.Database  // The label for the dropdown option
          }));
          console.log(dropdownOptions);
          setDatabaseOptions(dropdownOptions)
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }


  const Fetchdatabaseinfo = () => {
    let payload = {

      query:`Select * from process_data.file_configuration;`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
       if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
      }

        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }


  const Fetcheditinfo = (id) => {
    let payload = {

      query:`Select * from process_data.file_configuration where primary_id = '${id}';`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
	  console.log("edit data",data)
	  console.log("edit source data",data[0].source_id)
	  setConfigName(data[0].file_config_name);
	  const source = JSON.parse(data[0].source_id);
	  const databasesource = JSON.parse(data[0].setdatabase);
	  console.log("edit source",source)

	  setDescription(data[0].description);
	  handleSourceselection({ value: source.value, label: source.label })
	  if (source && source.value && source.label) {
	      setSelectedSource({ value: source.value, label: source.label });
 	   } else {
 	     console.error('Source ID format is incorrect:', source);
 	   };
	  if (databasesource && databasesource.value && databasesource.label) {
	      setDatabase({ value: databasesource.value, label: databasesource.label });
 	   } else {
 	     console.error('Source ID format is incorrect:', source);
 	   };

	  setHeaderid(data[0].primary_id);    
    const configuration = JSON.parse(data[0].configuration);

    // Map the segments to individual variables
    const rows_1 = configuration[0]?.drop_rows || [];
    const rows_2 = configuration[0]?.fill_rows || [];
    const rows_3 = configuration[0]?.renaming_columns || [];
    const rows_4 = configuration[0]?.duplicate_check || [];
    const rows_5 = configuration[0]?.value_corrections || [];
    const rows_6 = configuration[0]?.keep_columns || [];


    setRows(rows_1);
    setRows2(rows_2);
    setRows3(rows_3);
    setRows4(rows_4);
    setRows5(rows_5);
    setRows6(rows_6);
      
       if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

      }

        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }

useEffect(() => {
  console.log("Updated rows:", rows);
}, [rows]);


  const handleAddRow = () => {
const lastRow = rows[rows.length - 1]; // Get the last row in the array
  const newId = lastRow ? lastRow.id + 1 : 1; // If there's no row, start with 1; otherwise, increment the last row's id

    setRows([...rows, {id: newId, schema: null, table: null, header: null, function: null, customOptions: {} }]);
  };

   const handleSelectChange123 = (index, field, selectedOption) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = selectedOption;
    console.log('field',field)
    if (field === 'schema') {
     // Fetch tables when schema changes
     fetchtabledata(selectedOption);
     setSelectedSchema(selectedOption);
    } else if (field === 'table') {
     // Fetch tables when schema changes
     fetchheaderdata(selectedOption);
    }
    setRows(updatedRows);
  };

useEffect(() => {
  
  FetchSourcenames();
  Fetchdatabaseinfo1();
  fetchTableInfo1();
  Fetchdatabaseinfo();
},[]);


  return (
<>
  <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
    <div style={{ width: '100%' }}>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab" }}>FILE CONFIG</h2>
    </div>
  </Grid>
  <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
    <Grid.Row>
      <Grid.Column>
        <div className="form-group">
          <label className="label1 mb-1" htmlFor={`configNameInput`}>Config Name</label>
          <div>
            <Input
              type="text"
              className="resource_input"
              style={{ width: '12em' }}
              placeholder="Relationship name"
              value={configName}
              onChange={(e) => setConfigName(e.target.value)}
            />
          </div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="form-group">
          <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label>
          <div>
            <Input
              type="text"
              className="resource_input"
              style={{ width: '12em' }}
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
      </Grid.Column>

      <Grid.Column>
        <div className="form-group">
          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Database</label>
          <Select
            clearable
            options={identifier1}
            selection
            className="resource_input"
            size='mini'
            value={database}
            onChange={handleSelectChange}
          />
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="form-group">
          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Source Name</label>
          <Select
            clearable
            options={sources}
            selection
            className="resource_input"
            size='mini'
            value={selectedSource}
            onChange={handleSourceselection}
          />
        </div>
      </Grid.Column>

    </Grid.Row>
  </Grid>
  <Grid.Row>
    <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{ margin: "10px" }}>
        <h3 onClick={toggleDiv1} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Drop Rows/Columns
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv1Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv1Open && (
  <div style={{ backgroundColor: "#fff", padding: "5px" }}>
    {rows.map((row, index) => (
      <div key={index} style={{ display: "flex", alignItems: "center", margin: "10px" }}>
        <Select
          options={[
            { key: 'value', label: 'Value', value: 'value' },
            { key: 'index', label: 'Index', value: 'index' },
            { key: 'empty_row', label: 'Empty Row', value: 'empty_row'},
            { key: 'after_empty_cell', label: 'After Empty Cell', value: 'after_empty_cell'},
            { key: 'drop_columns', label: 'Drop Columns', value: 'drop_columns'},
            { key: 'delete_rows', label: 'Delete Rows', value: 'delete_rows'},
            { key: 'keep_columns', label: 'Keep Columns', value: 'keep_columns'}


          ]}
          placeholder="Select Option"
          value={row.selectedOption}
          onChange={(e) => handleChange(index,'selectedOption', e)}
          style={{ marginRight: "10px", width: "12em" }}
        />

    {row.selectedOption && row.selectedOption.value === 'index' && (
      <input
        type="number"
        value={row.customoptions.index}
        onChange={(e) => handleCustomOptionChange(index, 'index', e.target.value)}
        placeholder="Enter an integer"
        className="custom-input"
        style={{ marginLeft: "40px",marginRight: "10px", width: "10em", color: "black" }}
      />
    )}
    {row.selectedOption && row.selectedOption.value === 'value' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Columns</label>
                          <Select
                      options={sourceColumns}
                      placeholder="Select Option"
                      value={row.customoptions.sourceColumns}
                      onChange={(e) => handleCustomOptionChange(index, 'sourceColumns', e)}
                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Check</label>
                   <input
                      type="text"
                      value={row.customoptions.value}
                      onChange={(e) => handleCustomOptionChange(index, 'value', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
  </Grid.Row>
    )}
    {row.selectedOption && row.selectedOption.value === 'after_empty_cell' && (
       <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.sourceColumns}
          onChange={(e) => handleCustomOptionChange(index,'sourceColumns', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
        />
    )}

{row.selectedOption && row.selectedOption.value === 'drop_columns' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Drop Condition</label>
      <Select
          options={[
                      { key: 'column_index', label: 'Column Index', value: 'column_index' },
                      { key: 'Column_name', label: 'Column Name', value: 'column_name'}
                    ]}
          placeholder="Select Option"
          value={row.customoptions.dropcondition}
          onChange={(e) => handleCustomOptionChange(index,'dropcondition', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>

    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Column</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.dropcolumns}
          onChange={(e) => handleCustomOptionChange(index,'dropcolumns', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Column Index</label>
                   <input
                      type="number"
                      value={row.customoptions.columnindex}
                      onChange={(e) => handleCustomOptionChange(index, 'columnindex', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
  </Grid.Row>
)}


{row.selectedOption && row.selectedOption.value === 'keep_columns' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Condition</label>
      <Select
          options={[
                      { key: 'column_index', label: 'Column Index', value: 'column_index' },
                      { key: 'Column_name', label: 'Column Name', value: 'column_name'}
                    ]}
          placeholder="Select Option"
          value={row.customoptions.keepcondition}
          onChange={(e) => handleCustomOptionChange(index,'keepcondition', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>

    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Column</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.keepcolumns}
          onChange={(e) => handleCustomOptionChange(index,'keepcolumns', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Column Index</label>
                   <input
                      type="number"
                      value={row.customoptions.columnindex}
                      onChange={(e) => handleCustomOptionChange(index, 'columnindex', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
  </Grid.Row>
)}

{row.selectedOption && row.selectedOption.value === 'delete_rows' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Column</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.droprows}
          onChange={(e) => handleCustomOptionChange(index,'droprows', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Drop Condition</label>
      <Select
          options={[
                      {key: 'null_rows', label: 'Empty Rows', value: 'null_rows'},
                      {key: 'non_null_rows', label: 'Not Empty Rows', value: 'non_null_rows'},
                      {key: 'index', label: 'Row Index', value: 'index'}
                    ]}
          placeholder="Select Option"
          value={row.customoptions.dropcondition}
          onChange={(e) => handleCustomOptionChange(index,'dropcondition', e)}
          style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Row Index</label>
                   <input
                      type="number"
                      value={row.customoptions.rowindex}
                      onChange={(e) => handleCustomOptionChange(index, 'rowindex', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>


  </Grid.Row>
)}



        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
          onClick={() => deleteRow(index)}
        />
        {/* Add + icon for the last row */}
        {index === rows.length - 1 && (
          <Icon
            name="plus"
            style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
            onClick={addRow}
          />
        )}
      </div>
    ))}
  </div>
)}
      </div>
    </Grid>
  </Grid.Row>
 <Grid.Row>
  <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
    <Grid.Column>
      <div style={{ margin: "10px" }}>
        <h3 onClick={toggleDiv2} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Fill Rows
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv2Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv2Open && (
          <div style={{ backgroundColor: "#fff", padding: "5px" }}>
            {rows2.map((row, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", margin: "10px" }}>
                <Grid.Column>
                  <Select
                    options={[
                      { key: 'fill_nulls', label: 'Fill Empty cells', value: 'fill_nulls' },
                      { key: 'fill_cell_values', label: 'Fill Cell Value', value: 'fill_cell_values' },
                      { key: 'column_splitter', label: 'Column Splitter', value: 'column_splitter'},
                    ]}
                    placeholder="Select Option"
                    value={row.selectedOption}
                    onChange={(e) => handleChange2(index, 'selectedOption', e)}
                    style={{ marginRight: "10px", width: "12em" }}
                  />
                </Grid.Column>

                {row.selectedOption && row.selectedOption.value === 'fill_nulls' && (
                  <Grid.Column>
                  </Grid.Column>
                )}

{row.selectedOption && row.selectedOption.value === 'column_splitter' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Column to split</label>
                          <Select
                      options={sourceColumns}
                      placeholder="Select Option"
                      value={row.customoptions.sourceColumns}
                      onChange={(e) => handleCustomOptionChange2(index, 'sourceColumns', e)}
                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Condition Column</label>
                          <Select
                      options={sourceColumns}
                      placeholder="Select Option"
                      value={row.customoptions.conditionColumns}
                      onChange={(e) => handleCustomOptionChange2(index, 'conditionColumns', e)}
                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                    />
    </Grid.Column>

    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Condition</label>
                   <input
                      type="text"
                      value={row.customoptions.condition}
                      onChange={(e) => handleCustomOptionChange2(index, 'condition', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>

    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value for condition fail</label>
                   <input
                      type="text"
                      value={row.customoptions.valueforfail}
                      onChange={(e) => handleCustomOptionChange2(index, 'valueforfail', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Column to place values</label>
                   <input
                      type="text"
                      value={row.customoptions.columnplacement}
                      onChange={(e) => handleCustomOptionChange2(index, 'columnplacement', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
                <Grid.Column>
                  <Select
                    options={[
                      { key: 'yes', label: 'Yes', value: 'yes' },
                      { key: 'no', label: 'No', value: 'no' },
                      { key: 'both_columns', label: 'Both Columns', value: 'both_columns'},
                    ]}
                    placeholder="Select Option"
                    value={row.customoptions.columndrop}
                    onChange={(e) => handleCustomOptionChange2(index, 'columndrop', e)}
                    style={{ marginRight: "10px", width: "12em" }}
                  />
                </Grid.Column>


  </Grid.Row>
)}

{row.selectedOption && row.selectedOption.value === 'fill_nulls' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Columns</label>
                          <Select
                      options={sourceColumns}
                      placeholder="Select Option"
                      value={row.customoptions.sourceColumns}
                      onChange={(e) => handleCustomOptionChange2(index, 'sourceColumns', e)}
                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Replace</label>
                   <input
                      type="text"
                      value={row.customoptions.valuetofill}
                      onChange={(e) => handleCustomOptionChange2(index, 'valuetofill', e.target.value)}
                      placeholder="Enter a value"
                      className="custom-input"
                      style={{ marginRight: "10px", width: "10em", color: "black", height:"35px" }}
                    />
    </Grid.Column>
  </Grid.Row>
)}




{row.selectedOption && row.selectedOption.value === 'fill_cell_values' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Excel Column</label>
      <Select
        options={generateColumnOptions()} // Dynamically generated column options
        placeholder="Select Column"
        value={row.customoptions.column} // Captures the selected column
        onChange={(e) => handleCustomOptionChange2(index, 'column', e)}
        style={{ width: "100%" }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Excel Row</label>
      <Select
        options={generateRowOptions()} // Dynamically generated row options
        placeholder="Select Row"
        value={row.customoptions.row} // Captures the selected row
        onChange={(e) => handleCustomOptionChange2(index, 'row', e)}
        style={{ width: "100%" }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Populating Column</label>
      <input
        type="text"
        value={row.customoptions.valuetofill}
        onChange={(e) => handleCustomOptionChange2(index, 'valuetofill', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
  </Grid.Row>
)}

                <Grid.Column>
                  <Icon
                    name="trash"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                    onClick={() => deleteRow2(index)}
                  />
                  {index === rows2.length - 1 && (
                    <Icon
                      name="plus"
                      style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
                      onClick={addRow2}
                    />
                  )}
                </Grid.Column>
              </div>
            ))}
          </div>
        )}
      </div>
    </Grid.Column>
  </Grid>
</Grid.Row>
  <Grid.Row>
    <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{ margin: "10px" }}>
        <h3 onClick={toggleDiv3} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Renaming Columns
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv3Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv3Open && (
          <div style={{ backgroundColor: "#fff", padding: "5px" }}>
            {rows3.map((row, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", margin: "10px" }}>
                <Grid.Column>
                          <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.selectedOption}
          onChange={(e, { value }) => handleChange3(index,'selectedOption', e)}
          style={{ marginRight: "10px", width: "12em" }}
        />
                </Grid.Column>


                {row.selectedOption && (
                  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
                      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Data Type</label>
                                    <Select
                                      options={[
                                         { key: 'data_entry', label: 'Data Entry', value: 'data_entry' },
                                         { key: 'database', label: 'Database', value: 'database' }
                                      ]}
                                      placeholder="Select Option"
                                      value={row.customoptions.columntype}
                                      onChange={(e) => handleCustomOptionChange3(index, 'columntype', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
                    </Grid.Column>
                  </Grid.Row>
                )}

{row.customoptions.columntype && row.customoptions.columntype.value === 'data_entry' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Populating Column</label>
      <input
        type="text"
        value={row.customoptions.renamingcolumn}
        onChange={(e) => handleCustomOptionChange3(index, 'renamingcolumn', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
  </Grid.Row>
)}

{row.customoptions.columntype && row.customoptions.columntype.value === 'database' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Schema</label>
                                    <Select
                                      options={databaseNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.schema}
                                      onChange={(e) => handleCustomOptionChange3(index, 'schema', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Table</label>
                                   <Select
                                      options={tableNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.table}
                                      onChange={(e) => handleCustomOptionChange3(index, 'table', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Columns</label>
                                  <Select
                                      options={headerNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.headername}
                                      onChange={(e) => handleCustomOptionChange3(index, 'headername', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
  </Grid.Row>
)}



                <Grid.Column>
                  <Icon
                    name="trash"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                    onClick={() => deleteRow3(index)}
                  />
                  {index === rows3.length - 1 && (
                    <Icon
                      name="plus"
                      style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
                      onClick={addRow3}
                    />
                  )}
                </Grid.Column>
              </div>
            ))}
          </div>
        )}
      </div>
    </Grid>
  </Grid.Row>
  <Grid.Row>
    <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{ margin: "10px" }}>
      <h3 onClick={toggleDiv4} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Duplicate Check
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv4Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv4Open && (
  <div style={{ backgroundColor: "#fff", margin: "10px" }}>
    {rows4.map((row, index) => (
      <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
       <div>
        <Select
          options={[
             { key: 'source', label: 'Source', value: 'source' },
             { key: 'database', label: 'Database', value: 'database'}
             ]}
          placeholder="Select Option"
          value={row.selectedOption}
          onChange={(e) => handleChange4(index, 'selectedOption', e)}
          style={{ marginRight: "10px", width: "12em" }}
          />
       </div>
{row.selectedOption && row.selectedOption.value === 'source' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Columns</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.headername}
          onChange={(e, { value }) => handleCustomOptionChange4(index,'headername', e)}
          style={{ marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
  </Grid.Row>
)}

{row.selectedOption && row.selectedOption.value === 'database' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Schema</label>
                                    <Select
                                      options={databaseNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.schema}
                                      onChange={(e, { value }) => handleCustomOptionChange4(index, 'schema', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Table</label>
                                   <Select
                                      options={tableNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.table}
                                      onChange={(e, { value }) => handleCustomOptionChange4(index, 'table', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Columns</label>
                                  <Select
                                      options={headerNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.headername}
                                      onChange={(e, { value }) => handleCustomOptionChange4(index, 'headername', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
  </Grid.Row>
)}

        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
          onClick={() => deleteRow4(index)}
        />
        {/* Add + icon for the last row */}
        {index === rows4.length - 1 && (
          <Icon
            name="plus"
            style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
            onClick={addRow4}
          />
        )}
      </div>
    ))}
  </div>
)}
      </div>
    </Grid>
  </Grid.Row>
  
<Grid.Row>
    <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{ margin: "10px" }}>
        <h3 onClick={toggleDiv5} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Value Corrections
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv5Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv5Open && (
  <div style={{ backgroundColor: "#fff", margin: "10px" }}>
    {rows5.map((row, index) => (
      <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
       <div>
        <Select
          options={[
             { key: 'source', label: 'Source', value: 'source' },
             { key: 'database', label: 'Database', value: 'database'}
             ]}
          placeholder="Select Option"
          value={row.selectedOption}
          onChange={(e) => handleChange5(index, 'selectedOption', e)}
          style={{ marginRight: "10px", width: "12em" }}
          />
       </div>
{row.selectedOption && row.selectedOption.value === 'source' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Columns</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.column}
          onChange={(e, { value }) => handleCustomOptionChange5(index,'column', e)}
          style={{ marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Correction Type</label>
                  <Select
                    options={[
                      { key: 'replace_values', label: 'Replace Values', value: 'replace_values' },
                      { key: 'date_format_correction', label: 'Date Format Correction', value: 'date_format_correction'}
                    ]}
                    placeholder="Select Option"
                    value={row.customoptions.correction_type}
                    onChange={(e) => handleCustomOptionChange5(index, 'correction_type', e)}
                    style={{ marginRight: "10px", width: "12em" }}
                  />
    </Grid.Column>

    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Check</label>
      <input
        type="text"
        value={row.customoptions.valuetocheck}
        onChange={(e) => handleCustomOptionChange5(index, 'valuetocheck', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Replace</label>
      <input
        type="text"
        value={row.customoptions.replace}
        onChange={(e) => handleCustomOptionChange5(index, 'valuetoreplace', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Date Format</label>
<Select
  options={[
    { key: '%d-%m-%Y', label: 'dd-mm-yyyy', value: '%d-%m-%Y' },
    { key: '%m-%d-%Y', label: 'mm-dd-yyyy', value: '%m-%d-%Y' },
    { key: '%Y-%m-%d', label: 'yyyy-mm-dd', value: '%Y-%m-%d' },
    { key: '%d/%m/%Y', label: 'dd/mm/yyyy', value: '%d/%m/%Y' },
    { key: '%m/%d/%Y', label: 'mm/dd/yyyy', value: '%m/%d/%Y' },
    { key: '%Y/%m/%d', label: 'yyyy/mm/dd', value: '%Y/%m/%d' },
    { key: '%d-%b-%Y', label: 'dd-Mon-yyyy', value: '%d-%b-%Y' },
    { key: '%d/%b/%Y', label: 'dd/Mon/yyyy', value: '%d/%b/%Y' },
    { key: '%b-%d-%Y', label: 'Mon-dd-yyyy', value: '%b-%d-%Y' },
    { key: '%d-%B-%Y', label: 'dd-Month-yyyy', value: '%d-%B-%Y' },
    { key: '%B-%d-%Y', label: 'Month-dd-yyyy', value: '%B-%d-%Y' },
    { key: '%Y-%m-%d %H:%M:%S', label: 'yyyy-mm-dd hh:mm:ss', value: '%Y-%m-%d %H:%M:%S' },
    { key: '%d-%m-%Y %H:%M:%S', label: 'dd-mm-yyyy hh:mm:ss', value: '%d-%m-%Y %H:%M:%S' },
    { key: '%m-%d-%Y %H:%M:%S', label: 'mm-dd-yyyy hh:mm:ss', value: '%m-%d-%Y %H:%M:%S' },
    { key: '%d/%m/%Y %H:%M:%S', label: 'dd/mm/yyyy hh:mm:ss', value: '%d/%m/%Y %H:%M:%S' },
    { key: '%m/%d/%Y %H:%M:%S', label: 'mm/dd/yyyy hh:mm:ss', value: '%m/%d/%Y %H:%M:%S' },
    { key: '%Y/%m/%d %H:%M:%S', label: 'yyyy/mm/dd hh:mm:ss', value: '%Y/%m/%d %H:%M:%S' },
    { key: '%H:%M:%S', label: 'hh:mm:ss', value: '%H:%M:%S' },
    { key: '%H:%M', label: 'hh:mm', value: '%H:%M' }
  ]}
  placeholder="Select Option"
  value={row.customoptions.dateformat}
  onChange={(e) => handleCustomOptionChange5(index, 'dateformat', e)}
  style={{ marginRight: "10px", width: "15em" }}
/>
    </Grid.Column>
  </Grid.Row>
)}
{row.selectedOption && row.selectedOption.value === 'database' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Schema</label>
                                    <Select
                                      options={databaseNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.schema}
                                      onChange={(e) => handleCustomOptionChange5(index, 'schema', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Table</label>
                                   <Select
                                      options={tableNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.table}
                                      onChange={(e) => handleCustomOptionChange5(index, 'table', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Columns</label>
                                  <Select
                                      options={headerNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.headername}
                                      onChange={(e) => handleCustomOptionChange5(index, 'headername', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Correction Type</label>
                  <Select
                    options={[
                      { key: 'replace_values', label: 'Replace Values', value: 'replace_values' },
                      { key: 'date_format_correction', label: 'Date Format Correction', value: 'date_format_correction'}
                    ]}
                    placeholder="Select Option"
                    value={row.customoptions.correction_type}
                    onChange={(e) => handleCustomOptionChange5(index, 'correction_type', e)}
                    style={{ marginRight: "10px", width: "12em" }}
                  />
    </Grid.Column>

    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Check</label>
      <input
        type="text"
        value={row.customoptions.valuetocheck}
        onChange={(e) => handleCustomOptionChange5(index, 'valuetocheck', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Value to Replace</label>
      <input
        type="text"
        value={row.customoptions.replace}
        onChange={(e) => handleCustomOptionChange5(index, 'valuetoreplace', e.target.value)}
        placeholder="Enter a value"
        className="custom-input"
        style={{
          width: "100%",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Date Format</label>
<Select
  options={[
    { key: '%d-%m-%Y', label: 'dd-mm-yyyy', value: '%d-%m-%Y' },
    { key: '%m-%d-%Y', label: 'mm-dd-yyyy', value: '%m-%d-%Y' },
    { key: '%Y-%m-%d', label: 'yyyy-mm-dd', value: '%Y-%m-%d' },
    { key: '%d/%m/%Y', label: 'dd/mm/yyyy', value: '%d/%m/%Y' },
    { key: '%m/%d/%Y', label: 'mm/dd/yyyy', value: '%m/%d/%Y' },
    { key: '%Y/%m/%d', label: 'yyyy/mm/dd', value: '%Y/%m/%d' },
    { key: '%d-%b-%Y', label: 'dd-Mon-yyyy', value: '%d-%b-%Y' },
    { key: '%d/%b/%Y', label: 'dd/Mon/yyyy', value: '%d/%b/%Y' },
    { key: '%b-%d-%Y', label: 'Mon-dd-yyyy', value: '%b-%d-%Y' },
    { key: '%d-%B-%Y', label: 'dd-Month-yyyy', value: '%d-%B-%Y' },
    { key: '%B-%d-%Y', label: 'Month-dd-yyyy', value: '%B-%d-%Y' },
    { key: '%Y-%m-%d %H:%M:%S', label: 'yyyy-mm-dd hh:mm:ss', value: '%Y-%m-%d %H:%M:%S' },
    { key: '%d-%m-%Y %H:%M:%S', label: 'dd-mm-yyyy hh:mm:ss', value: '%d-%m-%Y %H:%M:%S' },
    { key: '%m-%d-%Y %H:%M:%S', label: 'mm-dd-yyyy hh:mm:ss', value: '%m-%d-%Y %H:%M:%S' },
    { key: '%d/%m/%Y %H:%M:%S', label: 'dd/mm/yyyy hh:mm:ss', value: '%d/%m/%Y %H:%M:%S' },
    { key: '%m/%d/%Y %H:%M:%S', label: 'mm/dd/yyyy hh:mm:ss', value: '%m/%d/%Y %H:%M:%S' },
    { key: '%Y/%m/%d %H:%M:%S', label: 'yyyy/mm/dd hh:mm:ss', value: '%Y/%m/%d %H:%M:%S' },
    { key: '%H:%M:%S', label: 'hh:mm:ss', value: '%H:%M:%S' },
    { key: '%H:%M', label: 'hh:mm', value: '%H:%M' }
  ]}
  placeholder="Select Option"
  value={row.customoptions.dateformat}
  onChange={(e) => handleCustomOptionChange5(index, 'dateformat', e)}
  style={{ marginRight: "10px", width: "15em" }}
/>
    </Grid.Column>

  </Grid.Row>
)}

        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
          onClick={() => deleteRow5(index)}
        />
        {/* Add + icon for the last row */}
        {index === rows5.length - 1 && (
          <Icon
            name="plus"
            style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
            onClick={addRow5}
          />
        )}
      </div>
    ))}
  </div>
)}
      </div>
    </Grid>
  </Grid.Row>

  <Grid.Row>
    <Grid divided style={{ borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{ margin: "10px" }}>
      <h3 onClick={toggleDiv6} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
          Keep Columns
          <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
            {isDiv6Open ? '-' : '+'}
          </span>
        </h3>
        {isDiv6Open && (
  <div style={{ backgroundColor: "#fff", margin: "10px" }}>
    {rows6.map((row, index) => (
      <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
       <div>
        <Select
          options={[
             { key: 'source', label: 'Source', value: 'source' },
             { key: 'database', label: 'Database', value: 'database'}
             ]}
          placeholder="Select Option"
          value={row.selectedOption}
          onChange={(e) => handleChange6(index, 'selectedOption', e)}
          style={{ marginRight: "10px", width: "12em" }}
          />
       </div>
{row.selectedOption && row.selectedOption.value === 'source' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Source Columns</label>
      <Select
          options={sourceColumns}
          placeholder="Select Option"
          value={row.customoptions.headername}
          onChange={(e, { value }) => handleCustomOptionChange6(index,'headername', e)}
          style={{ marginRight: "10px", width: "12em" }}
       />
    </Grid.Column>
  </Grid.Row>
)}

{row.selectedOption && row.selectedOption.value === 'database' && (
  <Grid.Row style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
    <Grid.Column style={{ flex: "1", marginRight: "20px", marginLeft: "10px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Schema</label>
                                    <Select
                                      options={databaseNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.schema}
                                      onChange={(e, { value }) => handleCustomOptionChange6(index, 'schema', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1", marginRight: "20px" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Table</label>
                                   <Select
                                      options={tableNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.table}
                                      onChange={(e, { value }) => handleCustomOptionChange6(index, 'table', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />
    </Grid.Column>
    <Grid.Column style={{ flex: "1" }}>
      <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Columns</label>
                                  <Select
                                      options={headerNames}
                                      placeholder="Select Option"
                                      value={row.customoptions.headername}
                                      onChange={(e, { value }) => handleCustomOptionChange6(index, 'headername', e)}
                                      style={{ paddingLeft: "40px", marginRight: "10px", width: "12em" }}
                                    />

    </Grid.Column>
  </Grid.Row>
)}

        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
          onClick={() => deleteRow6(index)}
        />
        {/* Add + icon for the last row */}
        {index === rows6.length - 1 && (
          <Icon
            name="plus"
            style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
            onClick={addRow6}
          />
        )}
      </div>
    ))}
  </div>
)}
      </div>
    </Grid>
  </Grid.Row>

    
<Grid.Column>
    <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={handleSubmit}>Save</button>
  </Grid.Column>
<div
          className="ag-theme-alpine"
          style={{
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: '10px',
            width: `${columnDefs.length * 200}px`,
            maxWidth: '100%',
            maxHeight: '300px',
            height: '400px',
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            style={{ width: '100%' }}
          />
        </div>

</>
  )
}

export default Headerconfig;